import { useEffect } from "react";
import { useTheme } from "@/hooks/theme";

type ThemeProviderProps = {
    children: React.ReactNode;
};
export default function ThemeProvider({ children }: ThemeProviderProps) {
    const { setTheme } = useTheme();

    useEffect(() => {
        setTheme('dark');
    }, [setTheme]);

    return <>{children}</>;
}
